import { put, call, take, fork, select } from 'redux-saga/effects';
import { callApi } from './callApi';
import { successGames, failGames, successGameTags, successProviders, successProductsTypes } from '../actionCreators/casinoGames';
import { successGameCategories } from '../actionCreators/gameCategories';
import { successClubProducts } from '../actionCreators/club';
import { transformGamesData, makeProductList } from './helpers/transform';
import { getCurrentClubId, getGlobalAccount, getCurrentClubPlayerToken } from '../../store/selectors';
import config from '../../config/config';
import actionTypes from '../actionTypes';
import { successBettingGames } from '../actionCreators/bettingGames';
import { successLiveCasinoGames } from '../actionCreators/liveCasinoGames';

function* getGames({ isMobile }) {
  try {
    const skinId = yield select(getCurrentClubId);
    const token = yield select(getCurrentClubPlayerToken);
    const { clubId: gbSkinId, token: gbToken } = yield select(getGlobalAccount);
    const reqSkinId = skinId || gbSkinId;

    const params = {
      skinId: reqSkinId,
      token: token || gbToken,
      status: 'ok',
      device: isMobile ? 'mobile' : 'desktop'
    };
    const response = yield call( callApi, `${config.API_CASINO_URL}/lobby/allGames`, 'GET', params );
    const availableProducts = makeProductList(response.data);

    const { providers, games, gameTags, gameCategories, productsTypes } = transformGamesData(response.data, 'casino', 'liveCasino', 'casinoTournament','poker');
    yield put(successGames(games));
    yield put(successProviders(providers));
    yield put(successGameTags(gameTags));
    yield put(successGameCategories(gameCategories));
    yield put(successProductsTypes(productsTypes));
    yield put(successClubProducts([...availableProducts, ...gameCategories], reqSkinId));
    if('liveCasino' in response.data && Object.getOwnPropertyNames(response.data.liveCasino).length) {
      const { games : liveCasino } = transformGamesData(response.data,'liveCasino');
      yield put(successLiveCasinoGames(liveCasino));
    }
    // Parse sport game list
    //
    if('betting' in response.data && Object.getOwnPropertyNames(response.data.betting).length ) {
      const { games : bettingGames } = transformGamesData(response.data, 'betting');
      yield put(successBettingGames(bettingGames));
    }
  } catch (e) {
    yield put(failGames(e));
  }
}

export function* watchCasinoGamesRequest() {
  while(true) {
    const action = yield take(actionTypes.GAMES_REQUEST);
    yield fork(getGames, action);
  }
}
